import React, { useState } from 'react';

/**
 * Tooltip - Composant d'affichage d'une info-bulle au survol.
 *
 * @param {Object} props
 * @param {React.ReactNode} props.content - Contenu de l'info-bulle
 * @param {React.ReactNode} props.children - Élément cible du tooltip
 * @returns {JSX.Element}
 *
 * @example
 * <Tooltip content="Détail info"><Button>?</Button></Tooltip>
 */
export default function Tooltip({ children, content, className = '' }) {
  const [show, setShow] = useState(false);
  return (
    <span className={`relative inline-block ${className}`}
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
      onFocus={() => setShow(true)}
      onBlur={() => setShow(false)}
      tabIndex={0}
    >
      {children}
      {show && (
        <span className="absolute z-50 left-1/2 -translate-x-1/2 mt-2 px-3.5 py-2.5 bg-blue-gray-800 text-white text-sm rounded-lg shadow-lg min-w-[10rem] max-w-sm pointer-events-none transition-opacity duration-150 opacity-100">
          {content}
        </span>
      )}
    </span>
  );
} 